// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type QuestionMark24Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const QuestionMark24: FC<QuestionMark24Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="24"
            height="24"
        >
            <path d="M10.6 16c0-1.35.12-2.32.363-2.912.241-.592.754-1.238 1.537-1.938.683-.6 1.204-1.12 1.563-1.563.358-.441.537-.945.537-1.512 0-.683-.23-1.25-.688-1.7-.458-.45-1.095-.675-1.912-.675-.85 0-1.496.258-1.938.775-.441.517-.754 1.042-.937 1.575L6.55 6.95c.35-1.067.992-1.992 1.925-2.775C9.408 3.392 10.583 3 12 3c1.75 0 3.096.487 4.038 1.463.941.974 1.412 2.145 1.412 3.512 0 .833-.18 1.546-.537 2.138-.359.591-.921 1.262-1.688 2.012-.817.783-1.313 1.38-1.487 1.787-.175.409-.263 1.105-.263 2.088H10.6Zm1.4 6c-.55 0-1.02-.196-1.412-.587A1.926 1.926 0 0 1 10 20c0-.55.196-1.02.588-1.413A1.926 1.926 0 0 1 12 18c.55 0 1.02.196 1.412.587.392.392.588.863.588 1.413s-.196 1.02-.588 1.413A1.926 1.926 0 0 1 12 22Z" />
        </svg>
    );
};

export default QuestionMark24;
